import { SIM_CARDS_INVENTORY_FETCH_REQUESTED, SIM_CARDS_INVENTORY_FETCH_SUCCEEDED } from './types';
import { InventoryContextForType, InventoryType } from '../types';

export function fetchInventorySimcards() {
  return {
    type: SIM_CARDS_INVENTORY_FETCH_REQUESTED,
    payload: {},
  };
}

export function fetchInventorySimcardSuccess(
  // @ts-ignore
  productsList: firebase.firestore.QuerySnapshot
): {
  type: string;
  payload: InventoryContextForType<InventoryType.SIM_CARDS>[];
} {
  const espAq = productsList.docs.map(
    // @ts-ignore
    (doc: firebase.firestore.DocumentData) => {
      const data = doc.data();
      return {
        ...data,
        orgId: data?.org?.id,
        orgTitle: data?.org?.title,
        id: doc.id,
        updateTime: data?.updateTime?.toDate(),
      };
    }
  );
  return {
    type: SIM_CARDS_INVENTORY_FETCH_SUCCEEDED,
    payload: espAq,
  };
}
